import React from 'react';
import AppsTab from '../ChannelSettings/AppsTab';

interface AppsSelectionStepProps {
  selectedApps: string[];
  onAppsChange: (apps: string[]) => void;
  channelId?: string; // Add channelId prop
}

const AppsSelectionStep: React.FC<AppsSelectionStepProps> = ({ selectedApps, onAppsChange, channelId }) => {
  return (
    <AppsTab 
      key={channelId || 'no-channel'} 
      channelId={channelId} 
      pageSize={8}
      subCategory="Datasource"
    />
  );
};

export default AppsSelectionStep; 